import styled, { css } from "styled-components"
import { transparentize, maxWidth } from "utils"
import CloudinaryImage from "components/cloudinary-image"

export const FeatureContainer = styled.div`
  text-align: center;
  color: ${(props) => props.theme.component.text};
`

export const Image = styled(CloudinaryImage)`
  width: 6.2rem;
  height: 6.2rem;
  margin: 0 auto;
`

export const Divider = styled.hr`
  height: 1.8px;
  color: ${(props) => transparentize(0.6, props.theme.component.text)};
`

export const MiddleContainer = styled.div`
  margin-top: 3rem;
`

export const Value = styled.p`
  font-size: 1.6rem;
  text-align: center;
  line-height: 24.3px;
  font-weight: 400;
  margin-bottom: 0;
  margin-top: 1rem;
`

export const Label = styled.strong`
  font-size: 2.4rem;

  ${(props) => {
    if (!props.theme.component) return ""
    switch (props.theme.component.sectionHeading) {
      case "Type E":
        return css`
          color: #f4f3eb;
        `
      default:
        return null
    }
  }}
`
